var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { SABox } from '../box';
import { SASeparator } from '../separator/separator.component';
import { SAUX360Theme } from '../theme';
import { responsiveStyles, getBreakpoints } from '../utilities/responsive-styles';
var ColumnItem = styled(SABox)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    var columns = props.columns, spacing = props.spacing, theme = props.theme;
    var spacingFallbacks = {
        xs: spacing.xs,
        sm: spacing.sm || spacing.xs,
        md: spacing.md || spacing.sm || spacing.xs,
        lg: spacing.lg || spacing.md || spacing.sm || spacing.xs,
        xl: spacing.xl || spacing.lg || spacing.md || spacing.sm || spacing.xs,
    };
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      flex-grow: 0;\n      flex: 1;\n      box-sizing: border-box;\n      ", "\n    "], ["\n      flex-grow: 0;\n      flex: 1;\n      box-sizing: border-box;\n      ",
        "\n    "])), responsiveStyles(columns, spacingFallbacks)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n      "], ["\n      ",
        "\n      "])), function (column, space) {
        return column
            ? "\n        flex-basis: calc(" + (column / 12) * 100 + "% - " + (theme.size.spacer[space] || "0px") + ");\n        max-width: " + (column / 12) * 100 + "%;\n        "
            : "";
    }));
});
var ColumnWrapper = styled(SABox)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var spacing = _a.spacing, theme = _a.theme;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      display: flex;\n      flex-wrap: wrap;\n      ", "\n      .separator.horizontal {\n        width: 100%;\n        flex-basis: 100%;\n        ", "\n      }\n      .separator.vertical {\n        max-width: 0px;\n        align-self: stretch;\n        ", "\n      }\n    "], ["\n      display: flex;\n      flex-wrap: wrap;\n      ",
        "\n      .separator.horizontal {\n        width: 100%;\n        flex-basis: 100%;\n        ",
        "\n      }\n      .separator.vertical {\n        max-width: 0px;\n        align-self: stretch;\n        ",
        "\n      }\n    "])), responsiveStyles(spacing)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: ", ";\n  width: ", ";\n  & > *:not(.column-wrapper) {\n    padding: ", ";\n  }\n"], ["\n  margin: ",
        ";\n  width: ", ";\n  & > *:not(.column-wrapper) {\n    padding: ",
        ";\n  }\n"])), function (value) {
        return "-" + theme.size.spacer[value] + " 0 0 -" + theme.size.spacer[value] + "}";
    }, function (value) { return "calc(100% + " + theme.size.spacer[value] + ")"; }, function (value) {
        return theme.size.spacer[value] + " 0 0\n      " + theme.size.spacer[value];
    }), responsiveStyles(spacing)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), function (value) { return "" + theme.size.spacer[value]; }), responsiveStyles(spacing)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: ", ";\n    flex-basis: ", "\n  "], ["\n    margin-top: ", ";\n    flex-basis: ", "\n  "])), function (space) { return "" + theme.size.spacer[space]; }, function (space) { return "" + theme.size.spacer[space]; }));
});
export function SAColumns(_a) {
    var children = _a.children, columns = _a.columns, spacing = _a.spacing, theme = _a.theme, rest = __rest(_a, ["children", "columns", "spacing", "theme"]);
    var spacingValues = getBreakpoints(spacing);
    var modIndex = 0;
    return (React.createElement(ColumnWrapper, __assign({ spacing: spacingValues, className: "column-wrapper", theme: theme, "data-testid": "ColumnWrapper" }, rest), React.Children.map(children, function (child) {
        var _a, _b, _c, _d, _e;
        var columnValues = getBreakpoints(columns);
        var childItem;
        if (React.isValidElement(child)) {
            if (child.type !== SASeparator) {
                var itemColumns = {
                    xs: Array.isArray(columnValues.xs) && ((_a = columnValues.xs) === null || _a === void 0 ? void 0 : _a[modIndex]),
                    sm: Array.isArray(columnValues.sm) && ((_b = columnValues.sm) === null || _b === void 0 ? void 0 : _b[modIndex]),
                    md: Array.isArray(columnValues.md) && ((_c = columnValues.md) === null || _c === void 0 ? void 0 : _c[modIndex]),
                    lg: Array.isArray(columnValues.lg) && ((_d = columnValues.lg) === null || _d === void 0 ? void 0 : _d[modIndex]),
                    xl: Array.isArray(columnValues.xl) && ((_e = columnValues.xl) === null || _e === void 0 ? void 0 : _e[modIndex]),
                };
                childItem = (React.createElement(ColumnItem, { spacing: spacingValues, columns: itemColumns, "data-testid": "ColumnItem", theme: theme }, child));
                modIndex += 1;
            }
            else {
                childItem = child;
            }
        }
        else {
            childItem = child;
        }
        return childItem;
    })));
}
SAColumns.defaultProps = {
    columns: undefined,
    spacing: undefined,
    theme: SAUX360Theme,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=columns.component.js.map